import React, { Component } from 'react';
import TextField from '../../components/text-field';
import { validNumKey } from '../../lib/valid-key';

class NumberField extends Component {
  constructor(props) {
    super(props);
  }

  handleOnKeyDown = (e) => {
    validNumKey(e);
  }

  handleOnPaste = (e) => {
    const value = (e.originalEvent || e).clipboardData.getData('text/plain');
    if (!(/^\d+$/.test(value))) {
      e.preventDefault();
      e.stopPropagation();
    }
  }

  render() {
    const {
      ...rest
    } = this.props;

    return <TextField {...rest} onKeyDown={this.handleOnKeyDown} onPaste={this.handleOnPaste}/>;
  }
}

export default NumberField;

